import { SequenceManagerAction } from './SequenceManagerAction';
import { getMainAndAroundODB } from "../api/api";

const FTTHServiceabilityAction = {
    FTTH_SERVICEABILITY_UPDATE: 'FTTH_SERVICEABILITY_UPDATE',
    FTTH_UPDATE_MAP_LOCATION: 'FTTH_UPDATE_MAP_LOCATION',
    FTTH_GET_MAIN_AND_AROUND_ODBS: 'FTTH_GET_MAIN_AND_AROUND_ODBS',
    FTTH_CLEAR_ODBS: 'FTTH_CLEAR_ODBS'
}

const updateLocation = (lat: any, lng: any) => {
    return function (dispatch: any) {
        dispatch({ type: FTTHServiceabilityAction.FTTH_UPDATE_MAP_LOCATION, payload: { "lat": lat, "lng": lng } });
    }
}

const getOdbs = (lat: any, lng: any) => {
    return function (dispatch: any) {
        dispatch({ type: FTTHServiceabilityAction.FTTH_CLEAR_ODBS });
        getMainAndAroundODB(lat, lng).then((response: any) => {
            dispatch({ type: FTTHServiceabilityAction.FTTH_GET_MAIN_AND_AROUND_ODBS, payload: response });
        })
            .catch((error) => {
                dispatch({ type: FTTHServiceabilityAction.FTTH_GET_MAIN_AND_AROUND_ODBS, payload: error.response });
            })
    }
}

const updateFTTHServiceability = (address: any, notes: any, odb: any, provider: any, cityName: any, feasibility: any = "") => {
    return function (dispatch: any) {
        dispatch({ type: FTTHServiceabilityAction.FTTH_SERVICEABILITY_UPDATE, payload: { address: address, notes: notes, odb: odb, provider: provider, cityName: cityName, feasibility: feasibility } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['FTTHServiceability'] });
    }
}

export { FTTHServiceabilityAction, updateFTTHServiceability, updateLocation, getOdbs };